<template>
    <div class="card card-profile">
        <img :src="theme" class="card-img-top">

        <div class="row justify-content-center">
            <div class="col-lg-3 order-lg-2">
                <div class="card-profile-image">
                    <img :src="user.avatar" class="rounded-circle">
                </div>
            </div>
        </div>

        <!-- spacer -->
        <div class="card-header text-center border-0 pt-5 pb-4">
        </div>

        <div class="card-body pt-0">

            <div class="text-center">

                <h5 class="h3">
                    {{ user.name }}
                </h5>

                <div class="h5 font-weight-300">
                    <span v-if="user.owner">{{ user.owner.name }}</span>
                    <span v-if="user.entity"> / {{ user.entity.name }}</span>
                </div>

                <div class="h5 mt-4" v-if="showEmail">
                    <a :href="'mailto:'+user.email">
                        <i class="fas fa-envelope mr-1"></i> {{ user.email }}
                    </a>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    export default {

        props: {

            user: {
                type: Object,
                required: true
            },

            showEmail: {
                type: Boolean,
                default: false
            },
        },

        data() {
            return {
                theme: this.$baseURL + '/img/theme.jpg',
            }
        }
    }
</script>

<style scoped>

    .card-profile img {
        max-height: 150px;
    }

</style>

